module.exports = require("./uz-Arab-AF");